<template>
<div class="product-item" @click="gotoProduct(product)">
  <div class="left-box">
    <div class="product-name">{{product.product_name}}</div>
    <div class="product-need-days" v-if="product.need_days_shortest === product.need_days_longest">预计办理 {{ product.need_days_shortest }} 工作日</div>
    <div class="product-need-days" v-else>预计办理 {{ product.need_days_shortest }}-{{ product.need_days_longest }} 工作日</div>
  </div>
  <div class="right-box">
    <div class="price-box">
      <div class="symbol">￥</div>
      <div class="price">{{product.special_price ? product.special_price/100 : product.peer_price/100}}</div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    product: Object,
  },
  methods: {
    gotoProduct(item) {
      const routeData = this.$router.resolve({ name: 'product', params: { visa_product_id: item.visa_product_id }, query: { from: 'coupon_desc' } });
      window.open(routeData.href, '_blank');
    },
  },
};
</script>

<style lang="less" scoped>
.product-item{
  background: #FFFFFF;
  box-shadow: 0px 2px 6px 0px rgba(47, 51, 61, 0.06);
  border-radius: 2px;
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  padding: 14px 16px;
  &:hover{
    .left-box{
      .product-name{
        color: #599FFF;
      }
    }
  }
  .left-box{
    flex-grow: 1;
    overflow: hidden;
    .product-name{
      color: #2F333D;
      font-size: 18px;
      line-height: 25px;
      overflow : hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      font-weight: 600;
      max-height: 50px;
    }
    .product-need-days{
      margin-top: 4px;
      color: #91999F;
      font-size: 14px;
    }
  }
  .right-box{
    margin-left: 24px;
    .price-box{
      display: flex;
      align-items: baseline;
      color: #FF8033;
      font-size: 20px;
      line-height: 25px;
      .symbol{}
      .price{
        margin-left: 2px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/user-children/components/coupon-product-item.vue